import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function Comp() {
    const { useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');

    return (
        <div className={`${css.aniEGsapA1} aniEGsapA1`}>
            <div className="msg-box">
                <div className="box-l">
                    <span className="msg-color1">{t('smart_home_panel.eleven_des_white_pc1')} </span>
                    {t('smart_home_panel.eleven_des_white_pc2')}
                </div>
                <div className="box-r">{t('smart_home_panel.eleven_des_gray')}</div>
            </div>
            <div className="video-title">{t('smart_home_panel.electricity_video_title')}</div>
            <div className="video-box">
                <EFVideo sources={['/video/smarthomepanel/table_new.webm', '/video/smarthomepanel/table_new.mp4']} className="video" />
                <div className="v-axis v-axis-x">
                    {t('smart_home_panel.electricity_video_x_1')}
                    <div className="word-wrap"></div>
                    {t('smart_home_panel.electricity_video_x_2')}
                </div>
                <div className="v-axis v-axis-y">{t('smart_home_panel.electricity_video_y')}</div>
                <div className="axis-in-label">
                    <div className="axis-in-label-item axis-in-label-item-a">{t('smart_home_panel.electricity_video_label_in_1')}</div>
                    <div className="axis-in-label-item axis-in-label-item-b">{t('smart_home_panel.electricity_video_label_in_2')}</div>
                    <div className="axis-in-label-item axis-in-label-item-c">{t('smart_home_panel.electricity_video_label_in_3')}</div>
                </div>
                <div className="axis-bo-label">
                    <div className="axis-bo-label-item axis-bo-label-item-a">{t('smart_home_panel.electricity_video_label_bo_1')}</div>
                    <div className="axis-bo-label-item axis-bo-label-item-b">{t('smart_home_panel.electricity_video_label_bo_2')}</div>
                    <div className="axis-bo-label-item axis-bo-label-item-c">{t('smart_home_panel.electricity_video_label_bo_3')}</div>
                </div>
            </div>
        </div>
    );
}
